export const reducer = (state, action) => {
    switch (action.type) {
        case 'changeName': {
            return {
                ...state,
                name: action.payload,
            };
        }
        case 'changeAccount': {
            return {
                ...state,
                account: action.payload,
            };
        }
        case 'changeInn': {
            return {
                ...state,
                inn: action.payload,
            };
        }
        case 'changeKbk': {
            return {
                ...state,
                kbk: action.payload,
            };
        }
        case 'changeKpp': {
            return {
                ...state,
                kpp: action.payload,
            };
        }
        case 'changeRecipientAccount': {
            return {
                ...state,
                recipientAccount: action.payload,
            };
        }
        case 'changeRegistrationNumberSfr': {
            return {
                ...state,
                registrationNumberSfr: action.payload,
            };
        }
        case 'changeRegistrationNumber': {
            return {
                ...state,
                registrationNumber: action.payload,
            };
        }
        case 'changeBik': {
            return {
                ...state,
                bik: action.payload,
            };
        }
        case 'changePaymentAccount': {
            return {
                ...state,
                paymentAccount: action.payload,
            };
        }
        case 'changeShowConfirmationModal': {
            return {
                ...state,
                showConfirmationModal: action.payload,
            };
        }
    }
};
